import axios from 'axios';
import { URL_API } from '../config';
import { CreateLeadWithCustomerDto } from '../dtos/create-lead-with-customer.dto';

export const getLeadById = async (id: string) => {
    return await axios.get(`${URL_API}/leads/${id}`);
}

export const createLeadWithCustomer = async (
  payload: CreateLeadWithCustomerDto
) => {
  return await axios.post(`${URL_API}/leads/public/with-customer`, payload);
};